// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .skillsContainer h1 {
    margin-top: 20%;
    font-size: 2rem;
  }

  .skillWrap {
    width: 100%;
    padding: 12px;
  }

  .skillCardIntro {
    flex: 1;
    padding: 12px;
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: larger;
    font-weight: 500;
    letter-spacing: 1px;
    color: #56acb7;
  }

  .skillCard {
    width: 100%;
    margin-top: 42px;
    box-shadow: 10px 10px 10px #ddd;
    flex-direction: column;
  }

  .skillCardContent {
    padding: 4px;
  }

  #skillBean {
    margin: 8px;
  }

  #skillBean h5 {
    font-size: medium;
    color: #555;
    margin-left: 4px;
  }

  #skillBean span {
    color: #555;
    font-size: x-small;
  }
}

@media screen and (min-width: 992px) {
  .skillsContainer h1 {
    margin-top: 5%;
    font-size: 3rem;
  }

  .skillWrap {
    width: 80%;
    margin-top: 3%;
  }

  .skillCardIntro {
    flex: 1;
    color: white;
    padding: 12px;
    text-align: center;
    text-transform: capitalize;
    background-color: #56acb7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: x-large;
    font-weight: 300;
  }

  .skillCard {
    width: 80%;
    flex-direction: row;
    box-shadow: none;
  }

  .skillCardContent {
    padding: 8px;
  }

  #skillBean {
    /* background-color: #f3f3f3; */
    padding: 12px;
    margin: 24px;
    border-radius: 4px;
    box-shadow: 5px 5px 10px #ddd;
  }

  #skillBean h5 {
    color: #555;
  }

  #skillBean span {
    color: #555;
    font-size: small;
  }
}

.skillsContainer {
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skillsContainer h1 {
  font-weight: 500;
}

.skillWrap {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: tomato; */
}

.skillCard {
  background-color: white;
  display: flex;
}

.skillCardContent {
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.box:hover {
  box-shadow: 0px 0px 10px #bbb;
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/skills/Skills.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,OAAO;IACP,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB","sourcesContent":["@media screen and (max-width: 991px) {\n  .skillsContainer h1 {\n    margin-top: 20%;\n    font-size: 2rem;\n  }\n\n  .skillWrap {\n    width: 100%;\n    padding: 12px;\n  }\n\n  .skillCardIntro {\n    flex: 1;\n    padding: 12px;\n    text-transform: capitalize;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: larger;\n    font-weight: 500;\n    letter-spacing: 1px;\n    color: #56acb7;\n  }\n\n  .skillCard {\n    width: 100%;\n    margin-top: 42px;\n    box-shadow: 10px 10px 10px #ddd;\n    flex-direction: column;\n  }\n\n  .skillCardContent {\n    padding: 4px;\n  }\n\n  #skillBean {\n    margin: 8px;\n  }\n\n  #skillBean h5 {\n    font-size: medium;\n    color: #555;\n    margin-left: 4px;\n  }\n\n  #skillBean span {\n    color: #555;\n    font-size: x-small;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .skillsContainer h1 {\n    margin-top: 5%;\n    font-size: 3rem;\n  }\n\n  .skillWrap {\n    width: 80%;\n    margin-top: 3%;\n  }\n\n  .skillCardIntro {\n    flex: 1;\n    color: white;\n    padding: 12px;\n    text-align: center;\n    text-transform: capitalize;\n    background-color: #56acb7;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: x-large;\n    font-weight: 300;\n  }\n\n  .skillCard {\n    width: 80%;\n    flex-direction: row;\n    box-shadow: none;\n  }\n\n  .skillCardContent {\n    padding: 8px;\n  }\n\n  #skillBean {\n    /* background-color: #f3f3f3; */\n    padding: 12px;\n    margin: 24px;\n    border-radius: 4px;\n    box-shadow: 5px 5px 10px #ddd;\n  }\n\n  #skillBean h5 {\n    color: #555;\n  }\n\n  #skillBean span {\n    color: #555;\n    font-size: small;\n  }\n}\n\n.skillsContainer {\n  background-color: #f7f7f7;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.skillsContainer h1 {\n  font-weight: 500;\n}\n\n.skillWrap {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* background-color: tomato; */\n}\n\n.skillCard {\n  background-color: white;\n  display: flex;\n}\n\n.skillCardContent {\n  flex: 4;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.box:hover {\n  box-shadow: 0px 0px 10px #bbb;\n  transform: scale(1.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
